export enum LocalStorageVariablesType {
  CollapsedGroupIds = 'collapsedGroupIds',
  ResourceTreeExpandedNodeIds = 'resourceTreeExpandedNodeIds',
  HiddenDatabasePropertiesExpanded = 'hiddenDatabasePropertiesExpanded',
  HiddenDatabasePropertiesSeparated = 'hiddenDatabasePropertiesSeparated',
}
